import {AxiosResponse} from 'axios';
import {MessageProvider} from '../i18n/i18n';

type ErrorHandler = (msg: string) => void;

const errorHandlers: ErrorHandler[] = [];
let messageProvider: MessageProvider;

export function registerMessageProvier(t: MessageProvider) {
    messageProvider = t;
}

export function registerErrorCallback(errorHandler: ErrorHandler) {
    errorHandlers.push(errorHandler);
}

export function handleError<T>(errorMessage: string): (p: AxiosResponse<T>) => Promise<AxiosResponse<T>> {
    return (resp) => {
        errorHandlers.forEach((a) => a(messageProvider(errorMessage)));
        return Promise.reject(resp);
    };
}

export function handleErrorArray<T>(errorMessage: string): (p: AxiosResponse<T>) => T[] {
    return (resp) => {
        errorHandlers.forEach((a) => a(messageProvider(errorMessage)));
        return [];
    };
}



// WEBPACK FOOTER //
// ./src/apis/errorHandling.ts